/* SISA — PDP (V2): liberar scroll vertical sobre galería aunque el slider capture eventos */
(() => {
  const IS_PDP = () => document.body && document.body.classList.contains('template-product');

  // Selectores de cualquier galería/slider en PDP
  const GALLERY_SEL = [
    '.product__media-wrapper',
    '.product__media',
    '.product__media-list',
    '.product__media-sublist',
    '.media',
    '.product-media',
    '.product-gallery',
    '.slideshow',
    '.slider--product'
  ].map(s => `body.template-product ${s}`).join(',');

  const isInsideGallery = (node) => {
    if (!node) return false;
    return !!(node.closest && node.closest(GALLERY_SEL));
  };

  // Rueda/trackpad (desktop)
  const handleWheel = (e) => {
    if (!IS_PDP()) return;
    if (!isInsideGallery(e.target)) return;

    // Permite pinch-zoom (cmd/ctrl+wheel)
    if (e.ctrlKey) return;

    // Predominantemente vertical → hacemos scroll de la página y bloqueamos el carrusel
    const absX = Math.abs(e.deltaX || 0);
    const absY = Math.abs(e.deltaY || 0);
    if (absY >= absX) {
      // Cancelamos cualquier handler posterior (del carrusel) y prevenimos el default
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();

      // Hacemos scroll vertical de la ventana
      const amount = e.deltaY || 0;
      // behavior:auto evita animación forzada por el carrusel
      window.scrollBy({ top: amount, left: 0, behavior: 'auto' });
    }
    // Si es horizontal puro, dejamos que el slider lo use
  };

  // Táctil (mobile/tablet)
  let startX = 0, startY = 0, touching = false;
  const onTouchStart = (e) => {
    if (!IS_PDP()) return;
    const t = e.touches && e.touches[0];
    if (!t) return;
    touching = isInsideGallery(e.target);
    startX = t.clientX;
    startY = t.clientY;
  };

  const onTouchMove = (e) => {
    if (!IS_PDP()) return;
    if (!touching) return;
    const t = e.touches && e.touches[0];
    if (!t) return;
    const dx = t.clientX - startX;
    const dy = t.clientY - startY;

    // Si el gesto es mayormente vertical, bloqueamos al slider y dejamos pasar el scroll nativo
    if (Math.abs(dy) > Math.abs(dx)) {
      // En window (capture) detenemos que el carrusel consuma el evento
      e.stopImmediatePropagation();
      e.stopPropagation();
      // NO hacemos preventDefault para que el scroll nativo fluya
    }
  };

  const onTouchEnd = () => { touching = false; };

  // Registrar a nivel Window en CAPTURE para ejecutar antes que cualquier slider
  const add = (type, fn, opts={}) => {
    window.addEventListener(type, fn, { capture: true, passive: false, ...opts });
  };

  const init = () => {
    // Evita doble instalación
    if (window.__sisaUnlockScrollV2) return;
    window.__sisaUnlockScrollV2 = true;

    // Rueda (distintos nombres por compatibilidad)
    ['wheel', 'mousewheel', 'DOMMouseScroll'].forEach(evt => add(evt, handleWheel));

    // Táctil
    add('touchstart', onTouchStart, { passive: true });
    add('touchmove',  onTouchMove,  { passive: false }); // necesitamos poder frenar al slider
    add('touchend',   onTouchEnd,   { passive: true });
    add('touchcancel',onTouchEnd,   { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
